import { ChevronRight } from "lucide-react";
import { cn } from "../lib/utils";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const sunbedLinks = [
  { id: "packages", label: "Packages", path: "/sunbeds/packages" },
  { id: "memberships", label: "Memberships", path: "/sunbeds/memberships" },
  { id: "sunbeds", label: "Sunbeds", path: "/sunbeds/sunbeds" },
  {
    id: "customer-packages",
    label: "Customer Packages",
    path: "/sunbeds/customer-packages",
  },
];

export default function SunbedSubSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState("packages");

  // Sync activeId with current pathname
  useEffect(() => {
    const current = sunbedLinks.find((link) =>
      location.pathname.startsWith(link.path)
    );
    if (current) {
      setActiveId(current.id);
    }
  }, [location.pathname]);

  const handleMainLinkClick = (item: { id: string; path: string }) => {
    setActiveId(item.id);
    navigate(item.path);
  };

  return (
    <div className="flex flex-row lg:flex-col overflow-x-auto lg:overflow-y-auto w-full lg:w-56 bg-white py-2 lg:py-4 border-b lg:border-none lg:ml-2 lg:mt-3 scrollbar-hide">
      {sunbedLinks.map((item) => {
        const isActive = activeId === item.id;

        return (
          <div key={item.id}>
            <button
              onClick={() => handleMainLinkClick(item)}
              className={cn(
                "relative flex items-center px-4 py-2 text-[14px] lg:text-[15px] text-left transition-all duration-200 group whitespace-nowrap",
                isActive
                  ? "text-purple-600 font-semibold"
                  : "text-gray-800 hover:text-purple-600 hover:font-semibold"
              )}
            >
              <ChevronRight
                className={cn(
                  "absolute left-0 w-4 h-4 opacity-0 transform transition-all duration-200 hidden lg:block",
                  isActive
                    ? "opacity-100 text-purple-600 translate-x-0"
                    : "group-hover:opacity-100 group-hover:text-purple-600 group-hover:translate-x-0"
                )}
              />
              <span
                className={cn(
                  "transition-all duration-200",
                  isActive ? "lg:translate-x-4" : "lg:group-hover:translate-x-4",
                  isActive && "border-b-2 border-purple-600 lg:border-none pb-1 lg:pb-0"
                )}
              >
                {item.label}
              </span>
            </button>
          </div>
        );
      })}
    </div>
  );
}
